import React from 'react';
import { useRouteError, Link } from 'react-router-dom';
import './ErrorBoundary.css';

const ErrorBoundary = () => {
  const error = useRouteError();

  // Default error state
  let title = 'Oops!';
  let message = 'Something went wrong.';
  let actionText = 'Go back home';
  let actionLink = '/';

  // Customize based on error type
  switch (error?.status) {
    case 404:
      title = '404 - Page Not Found';
      message = 'The page you are looking for does not exist.';
      break;
    case 401:
      title = 'Unauthorized';
      message = 'You need to be signed in to access this page.';
      actionText = 'Sign in';
      actionLink = '/signin';
      break;
    case 403:
      title = 'Access Denied';
      message = 'You do not have permission to access this page.';
      actionText = 'Go to dashboard';
      actionLink = '/user/dashboard';
      break;
    default:
      if (error?.message) {
        message = error.message;
      }
      break;
  }

  return (
    <div className="error-page">
      <div className="error-page__container">
        <h1 className="error-page__title">{title}</h1>
        <p className="error-page__message">{message}</p>
        {error?.status && (
          <p className="error-page__status">Error {error.status}</p>
        )}
        <Link to={actionLink} className="error-page__button">
          {actionText}
        </Link>
      </div>
    </div>
  );
};

export default ErrorBoundary; 